import { PDFDownloadLink, PDFViewer, StyleSheet } from '@react-pdf/renderer';
import './App.css';
import Routes from './pages';
import RouteContextProvider from './RouteContext';
import IdBadge from './shared/components/Templates/IdBadge';
import { QRCode } from 'react-qrcode-logo';
import { useRef, useState } from 'react';
import { ATT_LIST } from "./constant/sample";
import CertificateAttendance from './shared/components/Templates/CertificateAttendance';
import { Bounce, ToastContainer } from 'react-toastify';

const styles = StyleSheet.create({
  viewer: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
});


function App() {

  return (
    <div className="app__wrapper">
      <RouteContextProvider>
        <Routes />
      </RouteContextProvider>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
        />
    </div>

    // <PDFViewer style={styles.viewer}>
    //   <CertificateAttendance />
    // </PDFViewer>

    // <div>{[...new Set([ATT_LIST].map(item => item.email))].map(email => <>{email} <br /></>)}</div>

    // <>
    //   <button onClick={() => setShouldGeneratePDFs(true)}>Generate PDFs</button>
    //   <button onClick={() => downloadAllPDFs()}>Download All PDFs</button>
    //   {shouldGeneratePDFs && qrLogos.map(qrItem => (
    //     <div className="pdf__downloadable">
    //       <PDFDownloadLink fileName={`${qrItem.name.replaceAll(".", "")} - ID Badge`} document={
    //         <IdBadge
    //           name={qrItem.name}
    //           position={qrItem.position}
    //           company={qrItem.company}
    //           qrcode={qrItem.qrRef.current?.canvasRef?.current?.toDataURL("image/png", 0.3)}
    //         />}>
    //         Download now
    //       </PDFDownloadLink>
    //     </div>
    //   ))}
    //   {/* <PDFViewer style={styles.viewer}>
    //     <IdBadge />
    //   </PDFViewer> */}

      // {qrLogos.map(qrItem => (
      //   <div style={{position: 'absolute', visibility: "hidden", zIndex: -1 }}>
      //     <QRCode
      //       value={qrItem.value}
      //       size={250}
      //       ref={qrItem.qrRef}
      //     />
      //   </div>
    //   ))}

    // </>
  );
}

export default App;
